import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { ToastHostComponent } from '../toast-host/toast-host.component';

@Component({
  selector: 'app-notification-host',
  standalone: true,
  imports: [ToastHostComponent, ConfirmDialogComponent],
  template: '<app-toast-host /><app-confirm-dialog />',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationHostComponent {}
